var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10703_648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9205 40.5205C70.252 39.1889 71 37.383 71 35.5C71 33.617 70.252 31.8111 68.9205 30.4795C67.589 29.148 65.783 28.4 63.9 28.4H42.6V7.1C42.6 5.21697 41.852 3.41105 40.5205 2.07954C39.189 0.748036 37.383 0 35.5 0C33.617 0 31.8111 0.748036 30.4795 2.07954C29.148 3.41105 28.4 5.21697 28.4 7.1V28.4H7.1C5.21697 28.4 3.41105 29.148 2.07954 30.4795C0.748036 31.8111 0 33.617 0 35.5C0 37.383 0.748036 39.1889 2.07954 40.5205C3.41105 41.852 5.21697 42.6 7.1 42.6H28.4V63.9C28.4 65.783 29.148 67.589 30.4795 68.9205C31.8111 70.252 33.617 71 35.5 71C37.383 71 39.189 70.252 40.5205 68.9205C41.852 67.589 42.6 65.783 42.6 63.9V42.6H63.9C65.783 42.6 67.589 41.852 68.9205 40.5205Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10703_648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71,
    height: 71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlus);
export default __webpack_public_path__ + "static/media/white-plus.2b3e357029ab9ce472872ea207063686.svg";
export { ForwardRef as ReactComponent };